/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2020 ООО АДАПТ info@acfs.spb.ru
 *
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { useQuery, useQueryClient } from 'react-query'

import { getUnmappedWorks } from '@builddocs/data-management'
import { unmappedWork } from './techzor.types'


interface IProjectHook {
  isLoading: boolean
  unmappedWorks: undefined | unmappedWork
  error?: unknown
  isError?: boolean
  refreshWorks: () => void
}

export const useUnmappedWorks = (contractId: string): IProjectHook => {
  const queryClient = useQueryClient()

  const {
    data: unmappedWorks,
    isLoading,
    isError,
    error,
  } = useQuery(['unmappedWorks', contractId], async () =>
    contractId ? await getUnmappedWorks(contractId) : undefined,
  )

  const refreshWorks = () =>
    queryClient.invalidateQueries(['unmappedWorks', contractId])

  return {
    unmappedWorks,
    isLoading,
    error,
    isError,
    refreshWorks,
  }
}

export default useUnmappedWorks
